export const OUTBOUND_MONTH = 'OUTBOUND_MONTH' as const;
export const INBOUND_MONTH = 'INBOUND_MONTH' as const;
export const OUTBOUND_DAY = 'OUTBOUND_DAY' as const;
export const INBOUND_DAY = 'INBOUND_DAY' as const;
export const PREFER_DIRECTS = 'PREFER_DIRECTS' as const;

export default {
  OUTBOUND_MONTH,
  INBOUND_MONTH,
  OUTBOUND_DAY,
  INBOUND_DAY,
  PREFER_DIRECTS,
};
